document.addEventListener("DOMContentLoaded", function () {
  const cards = [...document.querySelectorAll(".product-card--plp")];
  if (cards.length == 0) return;

  cards.map(function (card) {
    const button = card.querySelector(".atc-plp__button");
    const price = card.querySelector(".card-price");
    const nameRadio = card.getAttribute("data-name");
    const variant = [...card.querySelectorAll(`[name="${nameRadio}"]`)];
    const image_one = card.querySelector('img[data-plp-image="1"]');
    const image_two = card.querySelector('img[data-plp-image="2"]'); 

    variant.map(function (radio) {
      radio.addEventListener("click", function () {
        price.innerHTML = radio.getAttribute("data-price");
        image_one?.setAttribute("src", radio.getAttribute("data-image-one"));
        image_two?.setAttribute("src", radio.getAttribute("data-image-two"));
        card.querySelector('.atc-plp__button--notification').dataset.variant = this.dataset.variant;
        card.querySelector('.atc-plp__button--notification').dataset.variantId = this.value;
      });
    });

    button?.addEventListener("click", async function () {
      const checked = variant.find((item) => item.checked === true);
      if (!checked) return;
      console.log("awe");

      const event = new CustomEvent('onChangeCartDrawer', {
        bubbles: true,
        detail: {
          id: parseInt(checked.value),
          quantity: 1
        }
      });

      document.dispatchEvent(event);

      /*fetch("/cart/add.js", {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json",
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify({
          items: [
            {
              id: parseInt(checked.value),
              quantity: 1,
            },
          ],
        }), // body data type must match "Content-Type" header
      })
        .then((resp) => resp.json())
        .then((data) => {

        })
        .catch((error) => {
          alert("Has been error: " + error?.message);
        });*/
    });
  });
});